module.exports = __webpack_public_path__ + "media/images/plans/ceremony/hall-list/plan-ceremony-lineup-kyushu-3-9f5d6ac9c0d108798099e8e57ce2fae4.png";